import * as React from "react";
import { getCssValue } from "~/lib/cssValues";

import * as Turbo from "@hotwired/turbo";

import Emojify from "~/components/shared/Emojify";
import RemoteButtonComponent from "~/components/shared/RemoteButtonComponent";
import PipelineStateIcon from "~/components/shared/PipelineStateIcon";
import Icon from "~/components/shared/Icon";

import Database from "~/lib/Database";

import { titleForBrokenJob } from "~/components/build/Header/pipeline/utils/job";
import { Build, InputJob } from "~/components/build/Show/lib/types";

type Props = {
  job: InputJob;
  setBuildData?: (build: Build) => void;
  reloadBuild?: () => void;
  stepClassName: string;
};

// eslint-disable-next-line react/require-optimization
export default class ManualStep extends React.Component<Props> {
  render() {
    return (
      <div
        key={this.props.job.id}
        className="build-pipeline-job__wrapper inline-block"
        style={{ maxWidth: "15em" }}
      >
        {this.renderStep()}
      </div>
    );
  }

  stepArrow() {
    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 3px 0 5px",
          color: getCssValue("--base-0"),
        }}
      >
        <Icon icon="arrow-right" style={{ height: "14px", width: "14px" }} />
      </span>
    );
  }

  renderStep() {
    const { job, stepClassName, setBuildData, reloadBuild } = this.props;

    if (job.state === "broken") {
      const title = titleForBrokenJob(job);

      return <div className={stepClassName}>{this.stepContent({ job, title })}</div>;
    } else if (!job.permissions.activate.allowed) {
      return (
        <div
          aria-label={job.permissions.activate.message}
          data-title-tooltip={job.permissions.activate.message}
          className={stepClassName}
        >
          {this.stepContent({ job })}
        </div>
      );
    } else if (job.unblockedAt) {
      return <div className={stepClassName}>{this.stepContent({ job })}</div>;
    } else if (
      job.state === "skipped" ||
      job.state === "canceled" ||
      job.state === "blocked_failed"
    ) {
      return <div className={stepClassName}>{this.stepContent({ job })}</div>;
    }

    if (!setBuildData || !reloadBuild) {
      return (
        <a href={job.path} className={stepClassName}>
          {this.stepContent({ job })}
          {this.stepArrow()}
        </a>
      );
    }

    if (job.fields) {
      return (
        <a href="#" onClick={this.handleContinueButtonClick} className={stepClassName}>
          {this.stepContent({ job })}
          {this.stepArrow()}
        </a>
      );
    }

    return (
      <RemoteButtonComponent
        url={job.unblockPath}
        method="post"
        confirmText={job.prompt || "Unblock this step?"}
        className={stepClassName}
        onSuccess={(_event, response) => {
          if (response?.build) {
            const parsed = Database.parse(response.build);
            setBuildData(parsed);
          }
        }}
        onError={(_event, _response) => reloadBuild()}
      >
        {this.stepContent({ job })}
        {this.stepArrow()}
      </RemoteButtonComponent>
    );
  }

  handleContinueButtonClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    Turbo.visit(this.props.job.unblockDialogPath, {
      frame: "unblock_dialog",
    });
  };

  stepContent({ job, title }: { job: InputJob; title?: string | null | undefined }) {
    return (
      <div className="build-pipeline-job-content">
        <span className="build-pipeline-job__icon">
          <PipelineStateIcon job={job} />
        </span>
        <span className="truncate" style={{ maxWidth: "10em" }}>
          <Emojify
            text={job.name?.length ? job.name : "Continue"}
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
            title={title}
          />
        </span>
      </div>
    );
  }
}
